import { Box, useTheme, useMediaQuery } from '@mui/material';
import GoogleAdSense, { AD_SLOT } from './GoogleAdSense';
import { AD_TYPE, PAGE_TYPE } from '../../constants/gaEnums';

const SLOT_BY_PAGE = {
  [PAGE_TYPE.MYPAGE]: AD_SLOT.MYPAGE_INFEED,
  [PAGE_TYPE.NOTICE_MAIN]: AD_SLOT.NOTICE_INFEED,
  [PAGE_TYPE.LISTS_MAIN]: AD_SLOT.LISTS_INFEED,
  [PAGE_TYPE.REVIEWS_MAIN]: AD_SLOT.REVIEWS_INFEED,
  [PAGE_TYPE.NEWS_MAIN]: AD_SLOT.NEWS_INFEED_1,
  [PAGE_TYPE.REVIEWS_POST]: AD_SLOT.REVIEWS_POST_INFEED,
  [PAGE_TYPE.ARTIST]: AD_SLOT.ARTIST_MORE_INFEED,
  [PAGE_TYPE.SEARCH_MORE]: AD_SLOT.SEARCH_MORE_INFEED,
};

const InFeedAd = ({ pageType }) => {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('md'));
  const adType = isXs ? AD_TYPE.HORIZONTAL_320_50 : AD_TYPE.HORIZONTAL_728_90;

  return (
    <Box sx={{ py: { xs: '10px', md: '20px' } }}>
      <Box
        sx={{
          aspectRatio: { xs: '32 / 5', md: '728 / 90', lg: 'unset' },
          overflow: 'hidden',
          display: { lg: 'flex' },
          justifyContent: { lg: 'center' },
        }}
      >
        <GoogleAdSense
          adSlot={SLOT_BY_PAGE[pageType]}
          adType={adType}
          pageType={pageType}
          sx={{ width: { xs: '100%', lg: 728 }, height: { xs: '100%', lg: 90 } }}
        />
      </Box>
    </Box>
  );
};

export default InFeedAd;
